import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgDownloadIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 14 14"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M7 10.577 3.461 7.039l.708-.72L6.5 8.65V0h1v8.65l2.33-2.33.709.719zM1.616 14q-.69 0-1.153-.462-.462-.462-.463-1.154V9.961h1v2.423q0 .23.192.424a.58.58 0 0 0 .423.192h10.77a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.424V9.961h1v2.423q0 .69-.462 1.153-.462.462-1.154.463z"
    />
  </svg>
)
export default SvgDownloadIcon
